var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("COMMON_UPLOAD"),
        visible: "",
        width: "40%",
        "append-to-body": "",
      },
      on: { close: _vm.closeUpload },
    },
    [
      _c(
        "div",
        { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
        [_c("UploadTitleTips")],
        1
      ),
      _c(
        "el-upload",
        {
          ref: "uploadExchange",
          staticClass: "upload-drag",
          attrs: {
            "on-remove": _vm.handleRemove,
            data: {
              id: _vm.initData.id,
              siteId: _vm.getSite.siteId,
              source: "exchange",
            },
            headers: _vm.headers,
            "file-list": _vm.uploadFiles,
            "show-file-list": false,
            limit: _vm.limitNum,
            "on-progress": _vm.uploading,
            "on-change": _vm.uploadchange,
            "on-success": _vm.handleUploadSuccess,
            "on-exceed": _vm.handleExceed,
            "before-upload": _vm.beforeFileUpload,
            drag: "",
            action: _vm.actionUrl,
            "auto-upload": true,
            multiple: "",
          },
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _c(
            "div",
            {
              staticClass: "el-upload__text",
              staticStyle: { "word-break": "break-word" },
            },
            [
              _vm._v(_vm._s(_vm.$t("PAGE_PBC_UPLOAD_text1"))),
              _c("em", [_vm._v(" " + _vm._s(_vm.$t("PAGE_PBC_UPLOAD_text2")))]),
            ]
          ),
          _c("div", { staticClass: "el-upload__tip upload-rule-text" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("PAGE_PBC_UPLOAD_TIP", { size: 100 })) +
                "\n      "
            ),
          ]),
        ]
      ),
      _vm.uploadFiles.length
        ? _c(
            "div",
            { staticClass: "overflow-fileList-container" },
            _vm._l(_vm.uploadFiles, function (uploadFile) {
              return _c("div", { key: uploadFile.fileId }, [
                _c("div", { staticClass: "uploaded-cls" }, [
                  _c("span", [_vm._v(_vm._s(uploadFile.name))]),
                  uploadFile.status === "success"
                    ? _c(
                        "div",
                        [
                          [
                            _c("i", {
                              staticClass:
                                "el-icon-circle-check uploaded-checked-cls",
                              staticStyle: { color: "rgb(103, 194, 58)" },
                            }),
                            _c("i", {
                              staticClass: "el-icon-delete del-uploaded-cls",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(uploadFile)
                                },
                              },
                            }),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                uploadFile.status === "uploading"
                  ? _c(
                      "div",
                      {
                        staticClass: "progress-cls",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c("el-progress", {
                          staticStyle: { width: "95%" },
                          attrs: {
                            percentage: parseInt(uploadFile.percentage),
                            "stroke-width": 3,
                            format: _vm.formatProgress,
                          },
                        }),
                        uploadFile.status === "uploading" &&
                        uploadFile.percentage === 100
                          ? _c("i", {
                              staticClass: "el-icon-loading loading-cls",
                            })
                          : _vm._e(),
                        _c("i", {
                          staticClass: "el-icon-delete del-cls",
                          on: {
                            click: function ($event) {
                              return _vm.removeUploading(uploadFile)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }